import { render, staticRenderFns } from "./marketing-percent-setting.vue?vue&type=template&id=73eb2ac5"
import script from "./marketing-percent-setting.vue?vue&type=script&lang=js"
export * from "./marketing-percent-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports